// Búsqueda por código en el POS. Un lector de código de barras USB o
// Bluetooth funciona como un teclado: escribe el código muy rápido y termina
// con Enter. Con Enter en el buscador se agrega el producto cuyo código de
// barras (o SKU) coincide EXACTO; si no hay coincidencia exacta pero el
// filtro dejó un solo producto, se agrega ese.

const limpiar = (texto) => String(texto || '').replace(/\s+/g, '').toLowerCase();

export const buscarPorCodigo = (productos, texto) => {
  const codigo = limpiar(texto);
  if (!codigo) return null;
  return (
    productos.find((p) => p.codigoBarras && limpiar(p.codigoBarras) === codigo) ||
    productos.find((p) => limpiar(p.sku) === codigo) ||
    null
  );
};

// Filtro del buscador del POS: nombre, SKU o código de barras.
export const coincideBusquedaPos = (producto, termino) => {
  const t = String(termino || '').toLowerCase();
  return (
    producto.nombre.toLowerCase().includes(t) ||
    producto.sku.toLowerCase().includes(t) ||
    (producto.codigoBarras || '').toLowerCase().includes(t)
  );
};
